// FNP-79: read selection sets include the FNP-76 programmatic-provisioning
// fields (workflowId, progress, stageDomains, etc.) so the EditPage can
// render the live-progress section and the Profile can show the provisioned
// state without a second round-trip.

const APPLICATION_FIELDS = `
    id
    name
    description
    url
    logoUrl
    applicationCategory
    applicationStatus
    created
    updated
    displayName
    businessDomain
    applicationType
    parentDomainName
    subdomain
    deploymentAccountGroupId
    sourceRepositoryName
    infraRepositoryName
    sourcePipelineId
    infraPipelineId
    workflowId
    stepFunctionsExecutionArn
    statusReason
    statusUpdatedAt
    stageDomains { dev test prod }
    stageHostedZoneIds { dev test prod }
    stageCertificateArns { dev test prod }
    infraStackNames { dev test prod }
    progress { currentStep completedSteps failedStep }
    rollbackSummary {
        rolledBackSteps
        rollbackErrors { step error }
    }
    tags { key value }
`;

export const listApplications = `
   query listApplications($filter: ApplicationsFilterInput) {
       listApplications(filter: $filter) {
           items {
              ${APPLICATION_FIELDS}
           }
       }
   }
`;

export const getApplication = `
   query getApplication($id:ID!) {
       getApplication(id:$id) {
           ${APPLICATION_FIELDS}
       }
}`;
